<clr-modal [(clrModalOpen)]="isOpen" [clrModalSize]="'lg'">
  <h3 class="modal-title">Collaborator Institution Search</h3>

  <div class="modal-body">
    <form clrForm [formGroup]="searchForm">
      <div class="clr-row" style="margin-top: 0">
        <subs-input
          class="clr-col"
          label="Institution Name"
          controlName="institutionName"
          labelLength="4"
          helperText="Will return institutions that contain the entered
        text."
        ></subs-input>
      </div>
      <div class="clr-row">
        <subs-input
          class="clr-col"
          label="Duns Number"
          controlName="dunsNumber"
          labelLength="4"
          maxLength="13"
          helperText="Starts with the entered text."
          errorMessage="No hyphens."
        ></subs-input>

        <subs-input
          class="clr-col"
          label="UEI"
          controlName="uniqueEntityId"
          labelLength="4"
          maxLength="12"
          helperText="Starts with the entered text."
        ></subs-input>
      </div>
      <div
        *ngIf="shouldShowNoResultsMessage | async"
        class="alert alert-warning"
        role="alert"
      >
        <div class="alert-items">
          <div class="alert-item static">
            <div class="alert-icon-wrapper">
              <clr-icon
                class="alert-icon"
                shape="exclamation-triangle"
              ></clr-icon>
            </div>
            <span class="alert-text" data-test-id="alert-msg">
              There were no results for your search.
            </span>
          </div>
        </div>
      </div>
    </form>

    <subs-collaborator-institution-grid
      [institutionSearchResults]="searchResult"
      (institutionSelected)="isOpen = false"
      data-test-id="search-result-grid"
    >
    </subs-collaborator-institution-grid>
  </div>

  <div class="modal-footer">
    <subs-alert [alertBehavior]="alertSubject$"></subs-alert>
    <button
      type="button"
      class="btn btn-primary"
      [clrLoading]="submitState | async"
      (click)="search()"
      data-test-id="search-institution"
    >
      Search
    </button>

    <button
      type="button"
      class="btn btn-outline"
      (click)="clear()"
      data-test-id="clear-institution-search"
    >
      Clear
    </button>
    <button type="button" class="btn btn-outline" (click)="isOpen = false">
      Cancel
    </button>
  </div>
</clr-modal>
